import { getAxiosConfig } from '../../apisSetup/apiConfig';
import { PATHS } from 'AppConstants';

const ccbAxiosApiCaller = getAxiosConfig(PATHS.CCB_URL, true, {
}, false);

export const getReportDetails = (apidata) => ccbAxiosApiCaller.post(PATHS.GET_REPORTS_DETAILS, apidata);
export const searchReportDetails = (apiData) => ccbAxiosApiCaller.get(PATHS.GET_REPORTS_DETAILS_SEARCH, { params: { ...apiData } });
export const getReportFilterCount = (apidata) => ccbAxiosApiCaller.post( PATHS.GET_REPORT_FILTER_COUNT, apidata);
